package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TeachingAssignmentInput(
    @SerialName("class_section_id")
    val classSectionId: String,
    @SerialName("subject_ids")
    val subjectIds: List<String> = emptyList(),
    @SerialName("is_class_teacher")
    val isClassTeacher: Boolean = false,
    @SerialName("is_active")
    val isActive: Boolean = true
)

@Serializable
data class AddStaffWithAssignmentsRequest(
    @SerialName("school_id")
    val schoolId: String,
    @SerialName("employee_id")
    val employeeId: String,
    val name: String,
    @SerialName("role_title")
    val roleTitle: String? = null,
    @SerialName("auth_role")
    val authRole: String,
    val gender: String,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, String> = emptyMap(),
    @SerialName("is_active")
    val isActive: Boolean = true,
    val mobile: String,
    val email: String? = null,
    @SerialName("teaching_assignments")
    val teachingAssignments: List<TeachingAssignmentInput>? = null
)

@Serializable
data class SchoolStaffCreateRequest(
    @SerialName("school_id")
    val schoolId: String,
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("employee_id")
    val employeeId: String,
    val name: String,
    @SerialName("role_title")
    val roleTitle: String? = null,
    @SerialName("auth_role")
    val authRole: String,
    val gender: String,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, String> = emptyMap(),
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true,
    val mobile: String,
    val email: String? = null
)

@Serializable
data class SchoolStaffUpdateRequest(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("user_id")
    val userId: String? = null,
    @SerialName("employee_id")
    val employeeId: String? = null,
    val name: String? = null,
    @SerialName("role_title")
    val roleTitle: String? = null,
    @SerialName("auth_role")
    val authRole: String? = null,
    val gender: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, String>? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    val mobile: String? = null,
    val email: String? = null,
    @SerialName("push_notification_enabled") val pushNotificationEnabled: Boolean? = null,
    @SerialName("email_notification_enabled") val emailNotificationEnabled: Boolean? = null,
    @SerialName("profile_image_file_id") val profileImageFileId: String? = null
)

@Serializable
data class UpdateStaffWithAssignmentsRequest(
    @SerialName("employee_id")
    val employeeId: String? = null,
    val name: String? = null,
    @SerialName("role_title")
    val roleTitle: String? = null,
    @SerialName("auth_role")
    val authRole: String? = null,
    val gender: String? = null,
    @SerialName("custom_attributes")
    val customAttributes: Map<String, String>? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    val mobile: String? = null,
    val email: String? = null,
    @SerialName("teaching_assignments")
    val teachingAssignments: List<TeachingAssignmentInput>? = null
)
